import React, { ChangeEventHandler, MouseEvent, MouseEventHandler, ReactNode } from 'react'

interface IRadioProps {
  children: ReactNode
  name: string
  id: string
  onClick?: MouseEventHandler<HTMLLabelElement>
  isChecked?: boolean
  onChange?: ChangeEventHandler<HTMLInputElement>
  isDisabled?: boolean
}

export const Radio = (props: IRadioProps) => {
  const onClickLabel = (e: MouseEvent<HTMLLabelElement>) => {
    e.preventDefault()

    if (props.isDisabled) {
      return
    }

    if (props.onClick) {
      props.onClick(e)
    }
  }

  return (
    <>
      <input
        type="radio"
        className="rdo-box__ipt"
        name={props.name}
        id={props.id}
        checked={!!props.isChecked}
        onChange={e => e.preventDefault()}
        disabled={props.isDisabled}
      />
      <label className="rdo-box__lb" htmlFor={props.id} onClick={onClickLabel}>
        {props.children}
      </label>
    </>
  )
}
